import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { checkAdminPermission } from '../../services/adminAuth';
import { Loader, Text, Center, Alert, Button, Stack } from '@mantine/core';
import { IconAlertCircle, IconShieldLock } from '@tabler/icons-react';

export const AdminRoute = ({ children }) => {
  const { profile, isLogin, userLoading } = useUser();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        setLoading(true);
        setError(null);

        // 로그인 상태 확인
        if (userLoading) {
          return; // 로딩 중이면 대기
        }

        if (!isLogin || !profile) {
          console.log('User not logged in, redirecting to login');
          navigate('/');
          return;
        }

        // 관리자 권한 확인
        const hasPermission = await checkAdminPermission(profile.id);
        setIsAdmin(hasPermission);
        
        if (!hasPermission) {
          console.log(`User ${profile.id} does not have admin permission`);
          setError('관리자 권한이 필요합니다.');
        }
      } catch (error) {
        console.error('Admin route check failed:', error);
        setError('권한 확인 중 오류가 발생했습니다.');
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdmin();
  }, [isLogin, profile, userLoading, navigate]);

  // 로딩 중
  if (loading || userLoading) {
    return (
      <Center style={{ height: '100vh' }}>
        <Stack align="center" spacing="md">
          <Loader size="lg" />
          <Text size="lg" color="dimmed">관리자 권한 확인 중...</Text>
        </Stack>
      </Center>
    );
  }

  // 권한 없음
  if (!isAdmin) {
    return (
      <Center style={{ height: '100vh' }}>
        <Stack align="center" spacing="lg" style={{ maxWidth: 400 }}>
          <IconShieldLock size={64} color="red" />
          <Alert 
            icon={<IconAlertCircle size={16} />} 
            title="접근 권한 없음" 
            color="red"
            variant="filled"
          >
            <Text size="sm" mb="md">
              {error || '이 페이지에 접근할 권한이 없습니다.'}
            </Text>
            <Button 
              variant="white" 
              color="red" 
              onClick={() => navigate('/dashboard')}
              size="sm"
            >
              대시보드로 돌아가기
            </Button>
          </Alert>
        </Stack>
      </Center>
    );
  }

  // 권한 있음 - 자식 컴포넌트 렌더링
  return children;
}; 